import { Eyebrow, Heading, HeadingGroup, Lede, Subtitle } from './PageHeading.styles';
import type { PageHeadingProps } from './PageHeading.types';

export function PageHeading({
  title,
  subtitle,
  eyebrow,
  subtitlePlacement = 'inline',
  flush,
  centered,
  splitLines,
  fullWidth,
  mobileSpacing,
}: PageHeadingProps) {
  const subtitleBelow = subtitlePlacement === 'below';
  const centredFlag = centered ? 'true' : undefined;
  const blockLayout = {
    'data-flush': flush ? 'true' : undefined,
    'data-centered': centredFlag,
    'data-fullwidth': fullWidth ? 'true' : undefined,
    'data-mobile-spacing': mobileSpacing,
  };

  const inlineSubtitle = subtitle && !subtitleBelow && (
    <>
      {' '}
      <Subtitle data-block={splitLines ? 'true' : undefined}>{subtitle}</Subtitle>
    </>
  );

  if (!eyebrow && !subtitleBelow) {
    return (
      <Heading {...blockLayout}>
        {title}
        {inlineSubtitle}
      </Heading>
    );
  }

  return (
    <HeadingGroup {...blockLayout}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <Heading data-flush="true" data-fullwidth="true" data-centered={centredFlag}>
        {title}
        {inlineSubtitle}
      </Heading>
      {subtitle && subtitleBelow && <Lede>{subtitle}</Lede>}
    </HeadingGroup>
  );
}
